import { MODAL_EVENT_VISIBLE } from '@mirai/ui';

const ACCOMMODATION_TYPE = {
  ROOM: 1,
  APARTMENT: 2,
  PITCH: 3,
  ACCOMMODATION: 4,
  VILLA: 5,
};

const CALENDAR_FORMAT = 'DD/MM/YYYY';

const EVENT = {
  // -- @mirai/core
  BOOKING_RESPONSE: 'bookingResponse',
  BOOKING_CANCEL: 'bookingCancel',
  CHAT_CLOSE: 'chatClose',
  CHAT_OPEN: 'chatOpen',
  CHAT_OPENED: 'chatOpened',
  CHECKOUT_RESPONSE: 'checkoutResponse',
  CHECKOUT_FORM: 'checkoutForm',
  COOKIE_BANNER_OPEN: 'cookieBannerOpen',
  CORE_READY: 'coreReady',
  EXTERNAL_TWIN: 'externalTwin',
  FINDER: 'finder',
  FINDER_FIELD_CHANGE: 'finderFieldChange',
  FINDER_READY: 'finderReady',
  FOOTER_HEIGHT_CHANGE: 'footerHeightChenge',
  INTENT_CURRENCY: 'intentCurrency',
  INTENT_LOCALE: 'intentLocale',
  LOGGED: 'logged',
  LOGGED_OUT: 'loggedOut',
  LOGIN: 'login',
  LOCALE_CHANGED: 'localeChanged',
  METRICS: 'metrics',
  NOTIFICATION: 'notification',
  OTA_PRICES_READY: 'otaPricesReady',
  PAY_LATER: 'payLater',
  RATES_ADD_TO_CART: 'ratesAddToCart',
  RATES_RESPONSE: 'ratesResponse',
  RATES_FILTER_CLUB: 'ratesFilterClub',
  RATES_FILTER_PROMOCODE: 'ratesFilterPromocode',
  SARAI_MESSAGE_SENT: 'saraiMessageSent',
  // -- @mirai/ui
  MODAL_VISIBLE: MODAL_EVENT_VISIBLE,
};

const LOCALES = [
  'en-GB',
  'es-ES',
  'fr-FR',
  'de-DE',
  'ja-JP',
  'it-IT',
  'pt-PT',
  'da-DK',
  'fi-FI',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'ro-RO',
  'ru-RU',
  'sv-SE',
  'tr-TR',
  'zh-CN',
  'cs-CZ',
  'el-GR',
  'ar-DZ',
  'hu-HU',
  'ca-ES',
  'eu-ES',
  'vi-VN',
];

const MONTHS_IN_MOBILE = 3;

const OCCUPATION_TYPE = {
  GUEST: 1,
  ADULT: 2,
  CHILD: 3,
  BABY: 4,
};

const PAYMENT_CARD = {
  AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
  DINERS_CLUB: 'DINERS_CLUB',
  DISCOVER: 'DISCOVER',
  JCB: 'JCB',
  MAESTRO: 'MAESTRO', // low resolution logo
  MASTERCARD: 'MASTERCARD',
  UNIONPAY: 'UNIONPAY',
  VISA: 'VISA',
};

const PAYMENT_METHOD = {
  ALIPAY: 'ALIPAY',
  APLAZAME: 'APLAZAME',
  BIZUM: 'BIZUM',
  CARD: 'CARD',
  CARD_PREPAY: 'CARD_PREPAY',
  CRIPTAN: 'CRIPTAN',
  IDEAL: 'IDEAL',
  OXXO: 'OXXO',
  PAYLATER: 'PAYLATER',
  PAYPAL: 'PAYPAL',
  PCIPROXY: 'PCIPROXY',
  SCALAPAY: 'SCALAPAY',
  SOFORT: 'SOFORT',
  TPV: 'TPV',
  TRANSFER: 'TRANSFER',
  WECHATPAY: 'WECHATPAY',
};

const PAYMENT_PROVIDER = {
  ADDON: 'ADDON_PAYMENTS',
  ADYEN: 'ADYEN',
  CARDNET: 'CARDNET',
  CYBERSOURCE: 'CYBERSOURCE',
  HIPAY: 'HIPAY',
  HOTELPAY: 'HOTELPAY',
  GETNET: 'GETNET',
  LINKAGEPAY: 'LINKAGEPAY',
  MERCADOPAGO: 'MERCADOPAGO',
  MEWS: 'MEWS',
  MULTIPAGOS: 'MULTIPAGOS',
  NUVEI: 'NUVEI',
  OPENPAY: 'OPENPAY',
  PAYBOX: 'PAYBOX',
  PAYBYRD: 'PAYBYRD',
  PAYCOMET: 'PAYCOMET',
  PAYMOB: 'PAYMOB',
  PAYNOPAIN: 'PAYNOPAIN',
  REDSYS: 'REDSYS_V3',
  REDUNIQ: 'REDUNIQ',
  SHIFT4: 'SHIFT4',
  STRIPE: 'STRIPE',
  WORLDLINE: 'WORLDLINE_SAFERPAY',
};

const METRICS_EVENTS = {
  AURA_CALL_END: 'AURA:CALL_END',
  AURA_ERROR: 'AURA:ERROR',
  AURA_START: 'AURA:START',
  AURA_USAGE: 'AURA:USAGE',
  BOOKING_INTERACTION: 'BOOKING:INTERACTION',
  CHECKOUT_INTERACTION: 'CHECKOUT:INTERACTION',
  CHECKOUT_READY: 'CHECKOUT:READY',
  CHECKOUT_UNCONFIRMED: 'CHECKOUT:UNCONFIRMED',
  CONVERSATION_RATING: 'CONVERSATION:RATING',
  ERROR_CORE: 'ERROR:CORE',
  EXTRAS_INTERACTION: 'EXTRAS:INTERACTION',
  EXTRAS_READY: 'EXTRAS:READY',
  LOYALTY_INTERACTION: 'LOYALTY:INTERACTION',
  PRICE_COMP_INTERACTION: 'PRICE_COMP:INTERACTION',
  RATES_INTERACTION: 'RATES:INTERACTION',
  RATES_LOYALTY_INTERACTION: 'RATES:LOYALTY:INTERACTION',
  RATES_LOYALTY_READY: 'RATES:LOYALTY:READY',
  RATES_NO_AVAILABILITY: 'RATES:NO_AVAILABILITY',
  RATES_READY: 'RATES:READY',
  SARAI_CLOSE: 'SARAI:CLOSE',
  SARAI_INTERACTION: 'SARAI:INTERACTION',
  SARAI_OPEN: 'SARAI:OPEN',
  THREE_D_INTERACTION: '3D:INTERACTION',
};

const STEP = {
  BOOKING_CANCELLATION: 'CANCELLATION',
  BOOKING_CONFIRMATION: 'CONFIRMATION',
  CHECKOUT: 'CLIENTFORM',
  FINDER: 'BOOKINGENTRANCE',
  HOTELS: 'CHAINRESULT',
  RATES: 'BOOKINGSTEP1',
};

const SUBMIT_DELAY = 800;

export {
  ACCOMMODATION_TYPE,
  CALENDAR_FORMAT,
  EVENT,
  LOCALES,
  MONTHS_IN_MOBILE,
  OCCUPATION_TYPE,
  PAYMENT_CARD,
  PAYMENT_METHOD,
  PAYMENT_PROVIDER,
  METRICS_EVENTS,
  STEP,
  SUBMIT_DELAY,
};
